import roles from './roles';
import servicezugaenge from './servicezugaenge';
import update from './update';

export default {
  roles,
  servicezugaenge,
  update,
};
